var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"newsCenter"},[_c('Header',{attrs:{"bgColor":"rgba(34, 64, 116, 0.9)"}}),_c('ImgBox',{attrs:{"info":_vm.infoBoxInfo}}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }